module.exports = __webpack_public_path__ + "static/media/download.4cbcbb2b.svg";